import styled, {css, keyframes} from 'styled-components';

export const placeHolderShimmer = keyframes`
    0%{ background-position: -468px 0}
    100%{ background-position: 468px 0}
`;

export const LoaderAnimation = css`
  animation-fill-mode: forwards;
  animation: ${placeHolderShimmer} 1.25s linear infinite;
  background: #d1e5ff linear-gradient(to right, #d1e5ff 8%, #e0eaf6 18%, #d1e5ff 33%);
  background-size: 800px 104px;
  position: relative;
`;
export const LineLoader = styled.div`
  height: 16px;
  margin-bottom: 1rem;

  display: flex;
  width: ${props => props.width};
  height: ${props => props.height};
  ${LoaderAnimation}
`;
